import standardAPI from '@/api/standard_items';

const state = {
  events: [],
  events_status: '',
  events_MetaData: {},
  events_page: 1,
  events_perPage: 10,
};

const responseUrl = '/events';

const getters = {};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_events ({ commit }, getOptions) {
    commit('EVENTS_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('EVENTS_SUCCESS', response);
            commit('EVENTS_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('EVENTS_READY');
            reject(response);
          } else {
            commit('EVENTS_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_event ({ commit, dispatch }, itemData) {
    commit('EVENTS_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          commit('EVENTS_READY');
          resolve(response);
        } else {
          commit('EVENTS_READY');
          reject(response);
        }
      });
    });
  },
  edit_event ({ commit, dispatch }, itemData) {
    commit('EVENTS_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          commit('EVENTS_READY');
          resolve(response);
        } else {
          commit('EVENTS_READY');
          reject(response);
        }
      });
    });
  },
  remove_event ({ commit, dispatch }, itemData) {
    commit('EVENTS_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          commit('EVENTS_READY');
          resolve(response);
        } else {
          commit('EVENTS_READY');
          reject(response);
        }
      });
    });
  },
  reorder_event ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData: orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.events_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.events_perPage = max;
  },
  EVENTS_READY: (state) => {
    state.events_status = 'ready';
  },
  EVENTS_REQUEST: (state) => {
    state.events_status = 'loading';
  },
  EVENTS_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.events_MetaData.meta = response.meta;
      state.events_MetaData.links = response.links;
    }
    state.events = response.data;
    state.events_status = 'success';
  },
  EVENTS_ERROR: (state) => {
    state.events_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
